import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import type { AccountResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface AccountVcfcDetailsProps {
  className?: string;
  account: AccountResponse;
}

export const AccountVcfcDetails = (props: AccountVcfcDetailsProps) => {
  const { t } = useTranslation('accounts');

  return (
    <ul className={cn('flex flex-col gap-3', props.className)}>
      <li className='flex justify-between'>
        <Text weight='medium' size='xs'>
          {t('payment.tile.fields.accountNumber')}
        </Text>
        <Text weight='semibold' size='xs'>
          {props.account.accountNumber ? '***' + props.account.accountNumber.slice(-4) : 'No Data'}
        </Text>
      </li>
      <li className='flex justify-between'>
        <Text weight='medium' size='xs'>
          {t('payment.tile.fields.iban')}
        </Text>
        <Text weight='semibold' size='xs'>
          {props.account.iban}
        </Text>
      </li>
    </ul>
  );
};
